var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TableFooter as MuiTableFooter, TableRow as MuiTableRow } from '@mui/material';
import { renderFooterCell } from './utils/renderFooterCell';
export default function TableFooter(props) {
    var columns = props.columns, config = props.config, data = props.data, variant = props.variant;
    if (!data)
        return null;
    return (_jsx(MuiTableFooter, __assign({ sx: { position: 'sticky', bottom: 0 }, datatype: variant }, { children: _jsx(MuiTableRow, { children: columns.map(function (column, index) {
                return renderFooterCell({
                    index: index,
                    data: data,
                    column: column,
                    config: config
                });
            }) }) })));
}
